import {autoserializeAs, inheritSerialization} from 'cerialize';
import {RsvpQuestionOption} from './rsvp-question-option';
import {RsvpQuestion} from './rsvp-question';

@inheritSerialization(RsvpQuestion)
export class RsvpMultipleChoiceQuestion extends RsvpQuestion {
  public static readonly type = 'RsvpMultipleChoiceQuestion';
  public readonly type = RsvpMultipleChoiceQuestion.type;

  @autoserializeAs(RsvpQuestionOption, 'rsvp_question_options')
  public rsvpQuestionOptions: RsvpQuestionOption[] = [];
}
